import React from "react";
import { track } from "../../../../../analytics";
import "./TarifCard.scss";
import MyButton from "../../../../../UI/MyButton/MyButton";
import TarifIcon from "../../../../../UI/TarifIcon/TarifIcon";
import { useThemeImageLayers } from "../../../../../UI/TopImageLayers/useThemeImageLayers";
import { tarifBadgeText } from "../../tarifBadge";
const TarifCard = ({ tarifCards, show }) => {
  const { ready, primary, showLight, showDark } = useThemeImageLayers(
    tarifCards.top_img,
    tarifCards.top_img_dark
  );
  // суффикс цены из срока тарифа: 1 мес — "/мес", иначе "/N мес"
  const term = tarifCards.term_months ?? 1;
  const priceSuffix = term === 1 ? "/мес" : `/${term} мес`;
  /*
    Текст бейджа — поле stock («Акция / спецпредложение» в админке) с
    запасным «Новый» для Тамошо Pro и Pro Max, пока поле не заполнено.
    Правила в одном месте на обе вёрстки — см. tarifBadge.js. Пусто —
    бейджа нет.
  */
  const badgeText = tarifBadgeText(tarifCards);
  // рассрочка Alif: тот же бейдж, но кликабельный
  const isAlif = Boolean(tarifCards.link);
  return (
    <div className="tarifCard_block">
      <div className={"tarifCardTop_block" + (ready ? " is-ready" : "")}>
        {/*
          Два слоя вместо инлайнового background: светлый снизу, тёмный
          поверх него проявляется по opacity в тёмной теме. Порядок в DOM
          постоянный, монтированием управляет useThemeImageLayers: при
          первом рендере только слой активной темы, второй — в простое.
          Нет top_img_dark (в том числе null из старого кэша) — второго слоя
          нет, светлая картинка остаётся в обеих темах.
        */}
        {showLight ? (
          <img
            className="tarifCardTop_img"
            src={tarifCards.top_img}
            alt=""
            decoding="async"
            loading={primary === "light" ? "eager" : "lazy"}
          />
        ) : null}
        {showDark ? (
          <img
            className="tarifCardTop_img tarifCardTop_img--dark"
            src={tarifCards.top_img_dark}
            alt=""
            decoding="async"
            loading={primary === "dark" ? "eager" : "lazy"}
          />
        ) : null}
        {badgeText ? (
          isAlif ? (
            <a
              className="tarifCardTop_item tarifCardTop_item--alif"
              href="https://alifshop.tj/category/nets?cityId=1"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h4>{badgeText}</h4>
            </a>
          ) : (
            <div className="tarifCardTop_item">
              <h4>{badgeText}</h4>
            </div>
          )
        ) : null}
      </div>
      <div className="tarifCardBottom_block">
        <div className="tarifCardName_block">
          <h3>{tarifCards.name}</h3>
          <p>{tarifCards.title}</p>
        </div>
        <div className="tarifCardInfo_block">
          {tarifCards.tarif_infos?.map((e) => (
            <div className="tarifCardInfo_item" key={e.id}>
              {e.icon ? (
                <TarifIcon name={e.icon} className="tarifCardInfo_icon" />
              ) : (
                <img src={e.image} alt="" />
              )}
              <p>{e.text}</p>
            </div>
          ))}
        </div>
        {/*
          Нижняя группа единым блоком: при равной высоте слайдов запас
          собирается над ней, а не внутри. Полоса indicator_line и блок
          connect («Встречайте…») больше не рисуются — поля остались в
          данных и в админке, фронт их просто не показывает.
        */}
        <div className="tarifCardPin_block">
          <div className="tarifCardPrice_block">
            <div className="tarifCardPrice_item">
              <h2>{tarifCards.pref_price} TJS{priceSuffix}</h2>
              {tarifCards?.curr_price && <p>{tarifCards.curr_price} TJS</p>}
            </div>
            <h5>{tarifCards.stock}</h5>
          </div>
          {/* Кнопка во всю ширину карточки — как в карточке оборудования */}
          <div
            className="tarifCard_btn"
            onClick={() => {
              track("cta_click", {
                place: "tariff",
                label: "Подключить",
                tariff_name: tarifCards.name || "",
                category: tarifCards.is_promo ? "promo" : (tarifCards.term_months ?? 1) > 1 ? "year" : "home",
              });
              show(true);
            }}
          >
            <MyButton name={"Подключить"} width={"100%"} height={"44px"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TarifCard;
